<template>
 <!-- 雇主险管理-明细 -->
  <div>
    <div v-show="Gzxgl_detailed">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">雇主险管理-明细</div>
        <el-button style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;" @click="Return">返回</el-button>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:3%">
        <div style="height:40px"></div>
        <div style="display:inline-block">
           <span>组织架构</span>
           <el-cascader v-model="condition.organize_ids" clearable
               style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>城市 </span>
            <el-select v-model="condition.city_id" style="margin-left:10px;width:160px" placeholder="请选择城市" clearable>
            <el-option
                v-for="item in $globals.cityList"
                :key="item.city"
                :label="item.city"
                :value="item.city">
            </el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>姓名 </span>
          <el-input v-model="condition.staff_name" style="margin-left:10px;width:160px" placeholder="请输入姓名"></el-input>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>手机号 </span>
          <el-input v-model="condition.staff_telephone" style="margin-left:10px;width:160px" placeholder="请输入手机号"></el-input>
        </div>

        <div style="display:inline-block;margin-top:20px">
            <span>员工状态 </span>
            <el-select v-model="condition.staff_status" style="margin-left:10px;width:160px" placeholder="请选择离职状态" clearable>
            <el-option value="1" label="在职"></el-option>
            <el-option value="0" label="离职"></el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-left:20px;margin-top:20px">
            <span>缴纳状态 </span>
            <el-select v-model="condition.payment_status" style="margin-left:10px;width:160px" placeholder="请选择缴纳状态" clearable>
            <el-option value="0" label="未缴纳"></el-option>
            <el-option value="1" label="已缴纳"></el-option>
            <el-option value="2" label="未退保"></el-option>
            <el-option value="3" label="已退保"></el-option>
            <el-option value="4" label="应退保"></el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-left:20px">
            <span>导表状态 </span>
            <el-select v-model="condition.export_form_status" style="margin-left:10px;width:160px" placeholder="请选择导表状态" clearable>
            <el-option value="0" label="未导表"></el-option>
            <el-option value="1" label="已导表"></el-option>
            </el-select>
        </div>

        <!-- 按钮 -->
        <div style="display:inline-block;margin-left:20px">
            <el-button type="goon" @click="Find">查询</el-button>
            <el-button type="goon" @click="Payment">缴纳</el-button>
            <el-button type="goon" @click="Cancel">退保</el-button>
        </div>
        <div style="display:inline-block;margin-left:190px">
                <download-excel class="export-excel-wrapper" :fields="download_excel" title="缴纳人员清单"
                            name="缴纳人员清单.xls" :fetch="ExportForm"
                            style="margin-left:-180px;top:100px">
                    <el-button type="goon" >导表</el-button>
                </download-excel>
            </div>
      </div>

      <!-- 表格 -->
      <div style="margin:1% 3% 0 3%">
        <el-table
          :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          height="540"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
          </el-table-column>
          <el-table-column align="center" label="组织架构">
			  <template slot-scope="scope">
			  	{{$globals.group_name + "/" + scope.row.range}}
			  </template>
		  </el-table-column>
          <!-- <el-table-column prop="city_id" align="center"  label="城市"></el-table-column> -->
          <el-table-column prop="post_name" align="center" label="职位" width="110"></el-table-column>
          <el-table-column prop="staff_name" align="center" label="姓名" width="80"></el-table-column>
          <el-table-column prop="staff_card" align="center" label="身份证号" width="95"></el-table-column>
          <el-table-column prop="staff_telephone" align="center" label="手机号" width="110"></el-table-column>
          <el-table-column prop="start_date" align="center" label="入职时间" width="100"></el-table-column>
          <el-table-column prop="end_date" align="center" label="离职时间" width="100"></el-table-column>
          <el-table-column prop="payment_date" align="center" label="缴纳时间" width="100"></el-table-column>
          <el-table-column prop="staff_date" align="center" label="退保时间" width="100"></el-table-column>
          <el-table-column align="center" label="员工状态" width=100>
            <template slot-scope="scope">
                <img src="../../../assets/stateImg/状态_在职.png" v-show="scope.row.staff_status === '1'" />
                <img src="../../../assets/stateImg/状态_离职.png" v-show="scope.row.staff_status === '0'" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="缴纳状态" width=100>
            <template slot-scope="scope">
                <img src="../../../assets/stateImg/状态_未缴纳.png" v-show="scope.row.payment_status === '0'" />
                <img src="../../../assets/stateImg/状态_已缴纳.png" v-show="scope.row.payment_status === '1'" />
                <img src="../../../assets/stateImg/状态_未退保.png" v-show="scope.row.payment_status === '2'" />
                <img src="../../../assets/stateImg/状态_已退保.png" v-show="scope.row.payment_status === '3'" />
                <img src="../../../assets/stateImg/状态_应退保.png" v-show="scope.row.payment_status === '4'" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="导表状态" width=100>
            <template slot-scope="scope">
                <img src="../../../assets/stateImg/状态_未导表.png" v-show="scope.row.export_form_status === '0'" />
                <img src="../../../assets/stateImg/状态_已导表.png" v-show="scope.row.export_form_status === '1'" />
            </template>
          </el-table-column>

        </el-table>

        <!-- 分页 -->
        <el-row style="margin-top: 5px; text-align: center;">
          <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
            layout=" prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-row>
      </div>
      
    </div>
    </div>

  </div>
</template>

<script>

export default {
  props:["employer_id"],
  data() {
	  var organizeFind = async (e, spare8) => {
	  	var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
	  		identification: "1",
	  		organize_id: e,
	  		spare8: spare8,
	  	});
	  	return organizeList.data;
	  };
    return {
      //列表相关
      page_num: 1,
      page_size: 500,
      total: 0,
      tableData:[],

      download_excel: {
            "保单名称":"insurance_name",
            "投保账户":"insure_account",
            "承保公司":"company_name",
            "有效期开始时间":"start_date",
            "有效期截至时间":"end_date",
            "保单号":"policy_no",
            "组织架构": "range",
            "姓名": "staff_name",
            "职位": "post_name",
            "身份证号": {
                field: "staff_card",
                callback: value => {
                    return "&nbsp;" + value;
                }
            },
            "手机号": "staff_telephone",
            "员工状态": "is_staff_status",
            "入职日期": "insurance_date",
            "缴纳状态": "is_payment_status",
            "缴纳时间": "payment_date",
            "退保时间": "staff_date",
			"导表时间": "export_form_date",
        },


      //条件
      condition: {
        employer_id :"",
        organize_ids: [],
        city_id: "",
        staff_name: "",
        staff_telephone: "",
        staff_status: "",
        payment_status: "",
        export_form_status: ""
      },

      // 权限
      Gzxgl_detailed:true,

      //操作staff_list
      staff_list: [],
	  
	  //组织架构数据
	  organizeList: [],

      daobiao:[],
	  
	  //级联下拉配置
	  props: {
		  lazy: true,
		  async lazyLoad(node, resolve) {
		  	if (node.level === 0) {
		  		return resolve(await organizeFind('', 'group'));
		  	} else {
		  		resolve(await organizeFind(node.data.id, ''));
		  	}
		  },
	      value: "id",
	      label: "organize_name",
	      children: "organizeList",
	      checkStrictly: true,
	      multiple: true,
	  },
	  
      
    }
  },
  methods: {
    // 全选
    handleSelectionChange(val) {
        this.staff_list = [];
        val.forEach(item => {
            this.staff_list.push(item);
        })
    },
    //返回
    Return(){
        this.$parent.Return();
    },
    // 导表
    async ExportForm(){
        var temporary = [];
		this.condition.organize_ids.forEach(item => {
		    temporary.push(item[item.length - 1]);
		})
		var organize_ids = "";
		temporary.forEach(item => {
		    organize_ids += item + ",";
		})
        var url = 'EmployerDetailed/selectAllsUpdate';
        var record = {
            employer_id:this.condition.employer_id,
            organize_ids: organize_ids,
            city_id:this.condition.city_id,
            staff_name:this.condition.staff_name,
            staff_telephone:this.condition.staff_telephone,
            staff_status:this.condition.staff_status,
            payment_status:this.condition.payment_status,
            export_form_status:this.condition.export_form_status,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                if(data.length > 0){
                    this.$message.success("导表成功！文件下载中！");
                    this.Find(); 
                    return data;
                }else{
                    this.$message.success("没有可以导出的数据！");
                    return null;
                }
                
            } else {
                this.$message.warning(data);
            }
        }
    },

    //缴纳
    async Payment(){
        if(this.staff_list.length <= 0){
            this.$message.warning("请先选择操作数据！");
            return false;
        }
        
        var url = 'EmployerDetailed/update';
        var record = {
            category: "pay",
            employerList: this.staff_list
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.$message.success(data);
                this.Find();
            } else {
                this.$message.warning(data);
            }
        }
    },
    //取消
    async Cancel(){
        if(this.staff_list.length <= 0){
            this.$message.warning("请先选择操作数据！");
            return false;
        }
        
        var url = 'EmployerDetailed/update';
        var record = {
            category: "cancel",
            employerList: this.staff_list
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.$message.success(data);
                this.Find();
            } else {
                this.$message.warning(data);
            }
        }
    },
    //查询
    async Find(){
		var temporary = [];
		this.condition.organize_ids.forEach(item => {
		    temporary.push(item[item.length - 1]);
		})
		var organize_ids = "";
		temporary.forEach(item => {
		    organize_ids += item + ",";
		})
		
        var url = 'EmployerDetailed/selectAll';
        var record = {
            page_num: this.page_num,
            page_size: this.page_size,
            employer_id:this.condition.employer_id,
            organize_ids: organize_ids,
            city_id:this.condition.city_id,
            staff_name:this.condition.staff_name,
            staff_telephone:this.condition.staff_telephone,
            staff_status:this.condition.staff_status,
            payment_status:this.condition.payment_status,
            export_form_status:this.condition.export_form_status,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === '-2000') {
            this.$message.error('服务器未响应！请稍后重试');
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.tableData = data.list;
                this.total = data.total;
            } else {
                this.$message.warning('请求失败！请稍后重试');
            }
        }
    },
    //分页
    handleCurrentChange(val){
        this.page_num = val;
        this.Find();
    },
	//初始化组织架构及下面的人
	async organizeFind() {
	    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
	        identification: "1",
	    });
	    this.organizeList = this.getTreeData(organizeList.data);
	
	},
	getTreeData(data) {
	    // 循环遍历json数据
	    for (var i = 0; i < data.length; i++) {
	
	        if (data[i].organizeList.length < 1) {
	            // children若为空数组，则将children设为undefined
	            data[i].organizeList = undefined;
	        } else {
	            // children若不为空数组，则继续 递归调用 本方法
	            this.getTreeData(data[i].organizeList);
	        }
	    }
	    return data;
	}
  },
  created(){
	this.organizeFind();
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// Gzxgl_detailed.vue?6f06b937